"use strict";

var _Dom = require("common/Dom");

var _Dom2 = _interopRequireDefault(_Dom);

var _themeA11y = require("@shopify/theme-a11y");

var _state = require("state");

var _state2 = _interopRequireDefault(_state);

var _Product = require("../components/Product");

var _Product2 = _interopRequireDefault(_Product);

require("styles/theme.scss");

require("styles/theme.scss.liquid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// PubSub.immediateExceptions = true;

// Common a11y fixes
// focusHash();
// bindInPageLinks();

// import PubSub from "pubsub-js";

_state2.default.init();

document.addEventListener("DOMContentLoaded", function () {
  if (!$(_Dom2.default.collectionContainer).length) {
    //Product.getAllProductsData();
  }
});

window.addEventListener("load", function () {});

// PubSub.subscribe('BVA', (message, data) => console.log(message, data));

// HMR
if (module.hot) {
  module.hot.accept();
}

// if (module.hot) {
//   module.hot.dispose(() => {
//     // reset/undo the behavior/side effect that as possibly enabled/enacted
//   });
// }